import React from "react";
import Image from "next/image";
import Link from "next/link";

const HireFromMilesFooter = ({ isMobile = false }: { isMobile?: boolean }) => {
  return (
    <>
      <footer
        className={`w-full mt-0 z-50 md:pt-28 ${
          isMobile ? "bg-transparent" : "bg-[#061A2F]"
        }`}
      >
        <div className="w-full ">
          <div className="text-center md:mb-40 md:block hidden">
            <Link
              href="#top"
              className="grp_btn flex justify-start items-center w-[192px] mx-auto"
            >
              <div className="w-[43px] h-[40px] rounded-full border-[1px] border-[#3174d6] flex justify-center items-center">
                <Image
                  priority
                  src="/images/business/arrow-up.png"
                  alt="upside arrow image"
                  className="h-[18px] new_arrow1"
                  width={18}
                  height={18}
                />
              </div>
              <div className="out_btn poppins_regular inline-block bg-[#061A2F]">
                <p className="healt_desk_btn text-[#3174d6] ">Scroll to top</p>
              </div>
            </Link>
          </div>

          <div className="lg:container mx-auto 2xl:p-0 lg:p-0 xl:px-6 md:px-6 lg:px-6 px-5 md:block hidden">
            <div className="mx-auto w-full ">
              <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 px_5">
                <div className="lg:pt-0 lg:pb-6 pb-6 pt-4 ">
                  <div className="md:justify-evenly sf_regular flex-wrap md:flex hidden">
                    <a
                      href="/about-us"
                      className="lg:text-[16px] lg:w-auto w-[100%] text-[18px] text-center md:text-left leading-[1.5rem] text-white sf_regular md:mt-3 mt-7 block"
                    >
                      {" "}
                      About Us{" "}
                    </a>
                    <a
                      href="/jobs/cpa"
                      className="lg:text-[16px] lg:w-auto w-[100%] text-[18px] text-center md:text-left leading-[1.5rem] text-white sf_regular md:mt-3 mt-7 block"
                    >
                      {" "}
                      Careers{" "}
                    </a>
                    <a
                      href="/alumni"
                      className="lg:text-[16px] lg:w-auto w-[100%] text-[18px] text-center md:text-left leading-[1.5rem] text-white sf_regular md:mt-3 mt-7 block"
                    >
                      {" "}
                      Alumni
                    </a>
                    <a
                      href="https://www.mileseducation.com/blog"
                      target="_blank"
                      className="lg:text-[16px] lg:w-auto w-[100%] text-[18px] text-center md:text-left leading-[1.5rem] text-white sf_regular md:mt-3 mt-7 block"
                    >
                      {" "}
                      Blogs{" "}
                    </a>
                    <a
                      href="https://www.mileseducation.com/us-jobs-for-accountants"
                      className="lg:text-[16px] lg:w-auto w-[100%] text-[18px] text-center md:text-left leading-[1.5rem] text-white sf_regular md:mt-3 mt-7 block"
                    >
                      {" "}
                      USP{" "}
                    </a>
                    <a
                      href="/events"
                      className="lg:text-[16px] lg:w-auto w-[100%] text-[18px] text-center md:text-left leading-[1.5rem] text-white sf_regular md:mt-3 mt-7 block"
                    >
                      Events{" "}
                    </a>
                    <a
                      href="/contact-us"
                      className="lg:text-[16px] lg:w-auto w-[100%] text-[18px] text-center md:text-left leading-[1.5rem] text-white sf_regular md:mt-3 mt-7 block"
                    >
                      {" "}
                      Contact Us{" "}
                    </a>
                  </div>

                  <div className="hidden">
                    <a
                      href="#"
                      className="lg:text-base text-[14px] leading-[1.5rem] text-white sf_regular underline decoration-solid mt-3 block"
                    >
                      US CPA Course
                    </a>
                  </div>
                  <div className="text-center hidden lg:mt-32 mt-10">
                    <p className="text-center pt-4 text-sm lg:w-auto w-full sf_regular text-white">
                      © 2011 - 2024 Copyright{" "}
                      <a
                        className="underline decoration-solid text-white"
                        href="https://www.mileseducation.com/"
                        target="_blank"
                      >
                        Miles Education Private Limited
                      </a>
                    </p>
                    <p className=" text-center pt-2 text-sm lg:w-auto w-full sf_regular text-white">
                      <a
                        className="underline decoration-solid text-white"
                        href="https://www.mileseducation.com/terms-and-conditions"
                        target="_blank"
                      >
                        Terms and Conditions
                      </a>
                      <span className="px-1 text-white">|</span>
                      <a
                        className="underline decoration-solid text-white"
                        href="https://www.mileseducation.com/privacy"
                        target="_blank"
                      >
                        Privacy Policy
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="text-right md:pb-24 md:hidden block mr-[20px] mb-[20px]">
            <Link href="#top" className="cursor-pointer inline-block">
              <Image
                src="/images/business/Arrow.png"
                alt="Special Offer"
                className=""
                width={43}
                height={43}
                priority
              />
            </Link>
          </div>
          <div className="md:hidden block">
            <Image
              src="/images/business/footer-line.png"
              alt="Footer"
              className="mx-auto"
              width={305}
              height={2}
              priority
            />
          </div>
          <div className="lg:container md:mx-auto 2xl:p-0 lg:p-0 xl:px-10 md:px-6 md:mt-0 mt-0 lg:px-6 mx-5">
            <hr className="border-t-[1px] border-white mx-auto mt-5 md:block hidden" />
            <div className=" flex w-full lg:py-10 md:py-8 pb-8 pt-[10px] justify-between flex-wrap items-center md:flex-row flex-col-reverse">
              <div className="flex md:flex-nowrap flex-wrap md:justify-start justify-center mt-0">
                <p className="md:text-left"></p>
                <div className="lg:text-[16px] md:text-lg text-[12px] leading-[1rem] md:order-1 order-2 text-white md:mt-0 mt-2 poppins_regular text-center lg:w-auto md:w-auto w-full">
                  <a
                    href="/terms-and-conditions"
                    className=" text-white inline-block"
                  >
                    General T&C
                  </a>
                  <span className="text-white px-2 inline-block">|</span>

                  <a href="/privacy" className=" text-white inline-block">
                    Privacy Policy
                  </a>
                  <span className="text-white px-2">|</span>
                  <a href="/cookie-policy" className="text-white inline-block">
                    Cookie Policy
                  </a>
                </div>
              </div>

              <div className="hidden md:flex items-center lg:justify-end justify-center md:order-2 order-1 lg:w-auto md:w-auto w-full lg:mt-0 md:mt-0 mt-0">
                <a
                  href="https://www.linkedin.com/school/mileseducation/"
                  target="_blank"
                  className="py-3"
                >
                  <Image
                    src="/images/accounting/linkw.png"
                    alt="Special Offer"
                    className="dark:invert duration-300 lg:mr-8 mr-6 lg:w-[22px] w-[20px]"
                    width={22}
                    height={26}
                  />
                </a>
                <a
                  href="https://www.facebook.com/miles.cpa.cma.cfa/"
                  target="_blank"
                  className="py-3"
                >
                  <Image
                    src="/images/accounting/facew.png"
                    alt="Special Offer"
                    className="dark:invert duration-300 lg:mr-8 mr-6 lg:w-[16px] w-[18px]"
                    width={28}
                    height={32}
                  />
                </a>
                <a
                  href="https://www.instagram.com/miles.accounting/"
                  target="_blank"
                  className="py-3"
                >
                  <Image
                    src="/images/accounting/instaw.png"
                    alt="Special Offer"
                    className="dark:invert duration-300 lg:mr-8 mr-6 lg:w-[22px] w-[24px]"
                    width={22}
                    height={26}
                  />
                </a>
                <a
                  href="https://www.youtube.com/user/milescpareview"
                  target="_blank"
                  className="py-3"
                >
                  <Image
                    src="/images/accounting/youw.png"
                    alt="Special Offer"
                    className="dark:invert duration-300 lg:mr-8 mr-6 lg:w-[24px] w-[24px]"
                    width={23}
                    height={17}
                  />
                </a>
                <a
                  href="https://twitter.com/mileseducation"
                  target="_blank"
                  className="py-3"
                >
                  <Image
                    src="/images/accounting/twitw.png"
                    alt="Special Offer"
                    className="dark:invert duration-300 lg:mr-8 mr-6 lg:w-[23px] w-[24px]"
                    width={24}
                    height={22}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default HireFromMilesFooter;
